import Create from './Create';
import Edit from './Edit';

export default {
  name: 'prices/movie',
  create: Create,
  edit: Edit,
};
